import cx from 'classnames'
import { RawButton } from '@/components/Button'
import { Badge } from '@/components/Badge'
import { Tooltip, TooltipTrigger } from '@/components/Tooltip'
import { Icon } from '@/components/Icon'
import styles from './ChatIconButton.module.css'
import { m } from 'motion/react'
import type { Transition } from 'motion-dom'

export interface ChatIconButtonProps {
  onPress?: () => unknown
  label: string
  badgeCount?: number
  isDisabled?: boolean
  avatarUrl?: string
  layout?: boolean
  layoutId?: string
  transition?: Transition
  testId?: string
}

/**
 * Motion-enabled raw button.
 */
const MotionRawButton = m.create(RawButton)

/**
 * An icon button used to indicate that a chat can be opened.
 */
export function ChatIconButton({
  onPress,
  isDisabled,
  label,
  avatarUrl,
  badgeCount = 0,
  layoutId,
  layout,
  transition,
  testId,
}: ChatIconButtonProps) {
  return (
    <TooltipTrigger>
      <MotionRawButton
        transition={transition}
        layout={layout && 'position'}
        layoutId={layoutId}
        isDisabled={isDisabled}
        onPress={onPress}
        testId={testId}
        className={({ isHovered, isPressed, isDisabled, isFocusVisible }) =>
          cx(
            styles.root,
            isHovered && styles.hover,
            isPressed && styles.pressed,
            isDisabled && styles.disabled,
            isFocusVisible && styles.focusVisible,
          )
        }
      >
        <div className={styles.badge}>
          <Badge hidden={badgeCount === 0}>{badgeCount}</Badge>
        </div>
        {avatarUrl ? (
          <img src={avatarUrl} className={styles.image} alt="Avatar" />
        ) : (
          <div className={styles.defaultIcon}>
            <Icon variant="active" name="support" />
          </div>
        )}
      </MotionRawButton>
      <Tooltip placement="bottom">{label}</Tooltip>
    </TooltipTrigger>
  )
}
